import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getMemberById, approveMember, suspendMember, reactivateMember } from '../../../services/members';
import Toast from '../../../components/Common/Toast';

const MemberApproval = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    loadMember();
  }, [id]);

  const loadMember = async () => {
    try {
      const data = await getMemberById(id);
      setMember(data);
    } catch (err) {
      setToast({ type: 'error', message: 'Failed to load member' });
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async () => {
    try {
      await approveMember(id);
      setToast({ type: 'success', message: 'Member approved' });
      navigate('/dashboard/org-admin/members');
    } catch (err) {
      setToast({ type: 'error', message: err.response?.data?.error });
    }
  };

  const handleSuspend = async () => {
    try {
      await suspendMember(id);
      setToast({ type: 'success', message: 'Member suspended' });
      navigate('/dashboard/org-admin/members');
    } catch (err) {
      setToast({ type: 'error', message: err.response?.data?.error });
    }
  };

  if (loading) return <div>Loading...</div>;
  if (!member) return <div>Member not found</div>;

  return (
    <div>
      <h1>Member Approval</h1>
      <p><strong>Name:</strong> {member.User?.full_name}</p>
      <p><strong>Email:</strong> {member.User?.email}</p>
      <p><strong>Phone:</strong> {member.User?.phone}</p>
      <p><strong>ID Number:</strong> {member.User?.id_number}</p>
      <p><strong>Admin Unit:</strong> {member.AdminUnit?.name}</p>
      <p><strong>Current Status:</strong> {member.status}</p>
      {member.status === 'pending' && <button onClick={handleApprove}>Approve Member</button>}
      {member.status === 'active' && <button onClick={handleSuspend}>Suspend Member</button>}
      {member.status === 'suspended' && <button onClick={handleApprove}>Reactivate</button>}
      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
};

export default MemberApproval;